import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const SelectPackage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch all packages
  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const response = await fetch("https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/packages");
      if (!response.ok) {
        throw new Error("Failed to fetch packages");
      }
      const data = await response.json();
      setPackages(data);
      setError(null);
    } catch (err) {
      console.error("Error fetching packages:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Collect features dynamically
  const getPackageFeatures = (pkg) =>
    Object.keys(pkg)
      .filter(
        (key) =>
          key.toLowerCase().startsWith("point") &&
          pkg[key] &&
          pkg[key].trim() !== ""
      )
      .map((key) => pkg[key]);

  return (
    <section
      className="pricing-section rel z-1 bg-dark-blue pt-125 rpt-95 pb-80 rpb-50"
      id="pricing"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-9 col-md-10">
            <div className="section-title text-center text-white mb-55">
              <span className="sub-title">Pricing Package</span>
              <h2>Best Pricing For Create Awesome Landing Web Design</h2>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="row justify-content-center">
            <div className="col-12 text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-white mt-3">Fetching packages...</p>
            </div>
          </div>
        ) : error ? (
          <div className="row justify-content-center">
            <div className="col-12">
              <div
                className="alert alert-danger d-flex align-items-center justify-content-center"
                role="alert"
              >
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                <div>{error}</div>
              </div>
            </div>
          </div>
        ) : packages.length === 0 ? (
          <div className="row justify-content-center">
            <div className="col-12 text-center py-5">
              <div className="empty-state-icon mb-3">
                <i className="bi bi-inbox fs-1 text-white"></i>
              </div>
              <h4 className="text-white">No Packages Available</h4>
              <p className="text-white-50">
                Please check back later or contact support
              </p>
            </div>
          </div>
        ) : (
          <div className="row large-gap justify-content-center">
            {packages.slice(0, 3).map((pkg, index) => (
              <div className="col-lg-4 col-sm-6" key={pkg._id || index}>
                <div
                  className={`pricing-item wow fadeInUp delay-0-${
                    (index + 1) * 2
                  }s ${index === 1 ? "featured" : ""}`}
                >
                  {index === 1 && <span className="price-type">Popular</span>}
                  <h5>{pkg.packageName}</h5>
                  <p>
                    {pkg.description}
                  </p>
                  <span className="price">{pkg.price} USD</span>
                  <Link to={`/buy/${pkg._id}`} className="theme-btn">
                    Choose Package <i className="fas fa-long-arrow-alt-right" />
                  </Link>
                  <ul className="list-style-two">
                    {getPackageFeatures(pkg).map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="pricing-right-circles wow customSlideInLeft delay-0-5s" />
    </section>
  );
};

export default SelectPackage;
